import s from './AdvantagesDisadvantagesCard.module.scss';
import {CircleMinus} from "@/app/[locale]/common/assets/CircleMinus/CircleMinus";
import {CirclePlus} from "@/app/[locale]/common/assets/CirclePlus/CirclePlus";
import {TAdvantagesDisadvantagesCardProps} from "@/app/[locale]/common/components/AdvantagesDisadvantagesCard/types";

export const AdvantagesDisadvantagesCard = ({ DISADVANTAGES, ADVANTAGES }: TAdvantagesDisadvantagesCardProps) => {
    return (
        <div className={s.card}>
            <div className={s.card_column}>
                <label>Disadvantages</label>
                <ul className={s.card_content}>
                    {
                        DISADVANTAGES.map((item: string, index: number) => (
                            <li key={index} className={s.card_item}>
                                <span><CircleMinus/></span>
                                <p className={s.card_text}>{item}</p>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <div className={s.card_column}>
                <label>Advantages</label>
                <ul className={s.card_content}>
                    {
                        ADVANTAGES.map((item: string, index: number) => (
                            <li key={index} className={s.card_item}>
                                <span><CirclePlus/></span>
                                <p className={s.card_text}>{item}</p>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    );
};